import React, { memo } from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { defaultMargin } from '../styles/common';

const CardBody = ({ children }) => (
	// Use a scrollview here NOT a view.
	// A view causes the CardFooter to align to the botom of the card body's child content
	// A scrollview acts like flex:1 should and aligns CardFooter buttons and content appropriately
	<ScrollView style={styles.body}>
		{children}
	</ScrollView>
);

const styles = StyleSheet.create({
	body: {
		marginHorizontal: defaultMargin,
	},
});

export default memo(CardBody);